import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackPetSafePlantsPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-motivation')
  }

  return (
    <FeedbackPage
      emoji="🐾"
      heading={t('pages.onboarding.feedbackPetSafePlants.heading')}
      text={t('pages.onboarding.feedbackPetSafePlants.text')}
      onSubmit={handleSubmit}
    />
  )
}
